module.exports = __webpack_public_path__ + "static/media/made-design-showroom.b1e61248.jpg";